import { render, staticRenderFns } from "./resultingMarkets.vue?vue&type=template&id=2ca8d5d8&"
import script from "./resultingMarkets.vue?vue&type=script&lang=js&"
export * from "./resultingMarkets.vue?vue&type=script&lang=js&"
import style0 from "./resultingMarkets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports